// extracted by mini-css-extract-plugin
module.exports = {"actions":"List_actions__3LcwN"};